const HomeSearchBar = () => ({
   replace: true,
   restrict: 'E',
   controller: 'SearchBoxCtrl',
   templateUrl: '/assets/homeSearchBar.html',
})


const PrimaryAnnouncements = () => ({
   replace: true,
   restrict: 'E',
   templateUrl: '/assets/primaryAnnouncements.html',
   scope: {
      section: '='
   }

})


const LinkedCards = () => ({
   replace: true,
   restrict: 'E',
   templateUrl: '/assets/linkedCards.html',
   scope: {
      section: '='
   }
})

const AboutLibrary = () => ({
   replace: true,
   restrict: 'E',
   templateUrl: '/assets/aboutLibrary.html',
   scope: {
      section: '='
   }
})

const SecondaryAnnouncements = () => ({
   replace: true,
   restrict: 'E',
   templateUrl: '/assets/secondaryAnnouncements.html',
   scope: {
      section: '='
   }
})


const Footer = (configService: ConfigService) => ({
   replace: true,
   restrict: 'E',
   templateUrl: '/assets/footer.html',
   scope: {
      section: '='
   },

   link(scope: any) {
      scope.footerLogoUrl = configService.data.homePage.footerLogoUrl
      scope.footerLogoEnabled = configService.data.homePage.footerLogoEnabled
      scope.footerLogoWidth = configService.data.homePage.footerLogoWidth
      scope.footerLogoHeight = configService.data.homePage.footerLogoHeight
   }
})


angular.module('summonApp.directives')
   .directive('homeSearchBar', [HomeSearchBar])
   .directive('primaryAnnouncements', [PrimaryAnnouncements])
   .directive('linkedCards', [LinkedCards])
   .directive('aboutLibrary', [AboutLibrary])
   .directive('secondaryAnnouncements', [SecondaryAnnouncements])
   .directive('footer', ['configService', Footer])
